export default {
  state: {
    recordsParams: {
      staff_id: 0,
      period: '',
      trade_if: 0,
      start: '',
      end: ''
    }

  },
  actions: {
    storeRecordsParams ({ commit }, data) {
      commit('setRecordsParams', data)
    }
  },
  mutations: {
    setRecordsParams (state, params) {
      state.recordsParams = params
    }
  },
  getters: {
    getRecordsParams (state) {
      return state.recordsParams
    }
  }
}
